import createIcon from '../../createIcon';

/**
 * @component @name ConnectedTv
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxN0MxIDE4LjEgMS45IDE5IDMgMTlIOFYyMUgxNlYxOUgyMUMyMi4xIDE5IDIyLjk5IDE4LjEgMjIuOTkgMTdMMjMgNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTIxIDE3SDNWNUgyMVYxN1pNNCAxNFYxNkg2QzYgMTQuODkgNS4xMSAxNCA0IDE0Wk00IDExVjEyLjQzQzUuOTcgMTIuNDMgNy41NyAxNC4wMyA3LjU3IDE2SDlDOSAxMy4yNCA2Ljc2IDExIDQgMTFaTTQgOFY5LjQ1QzcuNjEgOS40NSAxMC41NSAxMi4zOCAxMC41NSAxNkgxMkMxMiAxMS41OCA4LjQxIDggNCA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ConnectedTv = createIcon('ConnectedTv', [
  [
    'path',
    {
      d: 'M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17ZM4 14V16H6C6 14.89 5.11 14 4 14ZM4 11V12.43C5.97 12.43 7.57 14.03 7.57 16H9C9 13.24 6.76 11 4 11ZM4 8V9.45C7.61 9.45 10.55 12.38 10.55 16H12C12 11.58 8.41 8 4 8Z',
      key: '1mghoj',
    },
  ],
]);

export default ConnectedTv;
